import { render, staticRenderFns } from "./ProductDetailCatalog.vue?vue&type=template&id=30046f11&scoped=true"
import script from "./ProductDetailCatalog.vue?vue&type=script&lang=js"
export * from "./ProductDetailCatalog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30046f11",
  null
  
)

export default component.exports